import { render, staticRenderFns } from "./WebsiteStep.vue?vue&type=template&id=f88ae64c&scoped=true"
import script from "./WebsiteStep.vue?vue&type=script&setup=true&lang=js"
export * from "./WebsiteStep.vue?vue&type=script&setup=true&lang=js"
import style0 from "./WebsiteStep.vue?vue&type=style&index=0&id=f88ae64c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f88ae64c",
  null
  
)

export default component.exports